"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Ranges = exports.RangeTitle = exports.Range = exports.LoanCardBody = exports.DesktopRange = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _utils = require("@navinc/utils");

var _styles = require("./styles");

var _baseReactComponents = require("@navinc/base-react-components");

var _matchFactor = _interopRequireDefault(require("../match-factor"));

var _index = _interopRequireDefault(require("../match-factor-score/index.js"));

var _details = _interopRequireDefault(require("./details"));

var _offerLinkAttributes = require("../util/offer-link-attributes");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ScrollWayPoint = _styledComponents["default"].div.withConfig({
  displayName: "ScrollWayPoint",
  componentId: "sc-7mc6of-0"
})(["position:absolute;top:-55px;@media (", "){top:-105px;}"], _baseReactComponents.theme.forLargerThanPhone);

var Ranges = _styledComponents["default"].div.withConfig({
  displayName: "Ranges",
  componentId: "sc-7mc6of-1"
})(["display:flex;flex-direction:column;width:50%;@media (", "){flex-direction:row;width:100%;justify-content:space-between;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.Ranges = Ranges;

var Range = _styledComponents["default"].div.withConfig({
  displayName: "Range",
  componentId: "sc-7mc6of-2"
})([""]);

exports.Range = Range;
var DesktopRange = (0, _styledComponents["default"])(Range).withConfig({
  displayName: "DesktopRange",
  componentId: "sc-7mc6of-3"
})(["display:none;@media (", "){display:block;}"], _baseReactComponents.theme.forLargerThanPhone);
exports.DesktopRange = DesktopRange;

var Summary = _styledComponents["default"].div.withConfig({
  displayName: "Summary",
  componentId: "sc-7mc6of-4"
})(["margin:24px 0;display:grid;grid-template-columns:1fr;grid-row-gap:16px;grid-column-gap:16px;@media (", "){grid-template-columns:1fr 1fr;width:66.6%;}"], _baseReactComponents.theme.forLargerThanPhone);

var Content = _styledComponents["default"].div.withConfig({
  displayName: "Content",
  componentId: "sc-7mc6of-5"
})(["display:flex;justify-content:space-between;"]);

var RangeTitle = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "RangeTitle",
  componentId: "sc-7mc6of-6"
})(["&&{display:inline;}@media (", "){&&{display:block;}}"], _baseReactComponents.theme.forLargerThanPhone);
exports.RangeTitle = RangeTitle;

var LoanCardBody = function LoanCardBody(_ref) {
  var _ref$loanOffer = _ref.loanOffer,
      loanOffer = _ref$loanOffer === void 0 ? {} : _ref$loanOffer,
      _ref$isPersonal = _ref.isPersonal,
      isPersonal = _ref$isPersonal === void 0 ? false : _ref$isPersonal,
      order = _ref.order,
      detailLink = _ref.detailLink,
      yotpo = _ref.yotpo,
      _ref$loanType = _ref.loanType,
      loanType = _ref$loanType === void 0 ? '' : _ref$loanType,
      _onApplyNow = _ref.onApplyNow,
      _ref$hideMatchFactor = _ref.hideMatchFactor,
      hideMatchFactor = _ref$hideMatchFactor === void 0 ? false : _ref$hideMatchFactor,
      shouldUseMfScore = _ref.shouldUseMfScore,
      locationUrl = _ref.locationUrl,
      enterpriseUuid = _ref.enterpriseUuid,
      client = _ref.client,
      category = _ref.category,
      referralName = _ref.referralName,
      referralTarget = _ref.referralTarget,
      referralType = _ref.referralType;

  var _useLaunchDarkly = (0, _baseReactComponents.useLaunchDarkly)(),
      hasLDProvider = _useLaunchDarkly.hasProvider,
      trackOfferReferral = _useLaunchDarkly.trackOfferReferral;

  var scrollWayPointRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      shouldShowDetails = _useState2[0],
      setShouldShowDetails = _useState2[1];

  var toggleDetails = function toggleDetails() {
    return setShouldShowDetails(!shouldShowDetails);
  };

  var matchFactorScore = (0, _lodash["default"])(loanOffer, 'matchFactor');

  var scrollAndToggle = function scrollAndToggle() {
    toggleDetails();

    if (shouldShowDetails) {
      scrollWayPointRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  var trackNewTealiumConversion = function trackNewTealiumConversion() {
    (0, _utils.tealiumTrack)({
      tealium_event: 'referral',
      action: 'referral',
      category: category,
      label: locationUrl,
      matchFactorScore: matchFactorScore,
      accountId: enterpriseUuid,
      offerCategory: 'loans',
      offerId: loanOffer.id,
      offerName: loanOffer.name,
      offerSubCategory: isPersonal ? 'personal_loan' : loanType,
      offerBrand: loanOffer.issuer,
      order: order,
      referralName: referralName,
      referralTarget: referralTarget,
      referralType: referralType,
      rtid: loanOffer.rtid,
      rsid: loanOffer.rsid,
      offerLink: loanOffer.applyUrl,
      partnerId: '',
      client: client,
      value: 0
    });
  };

  var handleDetailsClick = function handleDetailsClick() {
    toggleDetails();
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ScrollWayPoint, {
      ref: scrollWayPointRef
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.FirstLook, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.WrapDiv, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LoanTitle, {
          size: "md",
          bold: true,
          "data-testid": "loancard:loan-title",
          children: (0, _lodash["default"])(loanOffer, 'name', '')
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Content, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Summary, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Range, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(RangeTitle, {
                size: "sm",
                light: true,
                children: "APR range"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
                size: "sm",
                light: true,
                bold: true,
                children: (0, _lodash["default"])(loanOffer, 'specifics.cost.description', '')
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Range, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(RangeTitle, {
                size: "sm",
                light: true,
                children: "Funding range"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
                size: "sm",
                light: true,
                bold: true,
                children: (0, _lodash["default"])(loanOffer, 'specifics.fundingAmount.description', '')
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(DesktopRange, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(RangeTitle, {
                size: "sm",
                light: true,
                children: "Repayment terms"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
                size: "sm",
                light: true,
                bold: true,
                children: (0, _lodash["default"])(loanOffer, 'specifics.repaymentTerms.description', '')
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(DesktopRange, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(RangeTitle, {
                size: "sm",
                light: true,
                children: "Funding speed"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
                size: "sm",
                light: true,
                bold: true,
                children: (0, _lodash["default"])(loanOffer, 'specifics.fundingSpeed.description')
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Img, {
            src: (0, _lodash["default"])(loanOffer, 'image.high', ''),
            alt: "".concat(loanOffer.issuer, " logo")
          })]
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ButtonBottomDiv, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ApplyButton, Object.assign({
        rel: "noopener noreferrer",
        target: "_blank",
        size: "large"
      }, (0, _offerLinkAttributes.offerLinkAttributes)((0, _lodash["default"])(loanOffer, 'applyUrl', '')), {
        "data-testid": "loancard:apply-button",
        onClick: function onClick() {
          !!hasLDProvider && trackOfferReferral(loanOffer);
          trackNewTealiumConversion();
          return !!_onApplyNow && _onApplyNow(loanOffer);
        },
        children: "Apply now"
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CardBottom, {
        children: [yotpo ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: yotpo.className,
          "data-appkey": yotpo.appkey,
          "data-domain": yotpo.domain,
          "data-product-id": yotpo.productId,
          "data-product-models": yotpo.productModels,
          "data-name": yotpo.name,
          "data-url": yotpo.url,
          "data-image-url": yotpo.imageUrl,
          "data-description": yotpo.description,
          "data-bread-crumbs": yotpo.breadCrumbs,
          "data-testid": "loancard:yotpo"
        }) : !hideMatchFactor && (shouldUseMfScore ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_index["default"], {
          score: matchFactorScore,
          onClick: toggleDetails
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_matchFactor["default"], {
          score: matchFactorScore,
          onClick: toggleDetails
        })), detailLink ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          size: "xs",
          shouldScaleFont: true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LoggedOutLink, {
            href: detailLink,
            children: "See details"
          })
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DetailsLink, {
          onClick: handleDetailsClick,
          shouldShowDetails: shouldShowDetails,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SeeDetails, {
            size: "sm",
            "data-testid": "loancard:see-details",
            children: shouldShowDetails ? 'Hide details' : 'See details'
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Chevron, {
            shouldShowDetails: shouldShowDetails,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
              name: "actions/carrot-up",
              color: _baseReactComponents.theme.neutral400
            })
          })]
        })]
      })]
    }), shouldShowDetails && /*#__PURE__*/(0, _jsxRuntime.jsx)(_details["default"], {
      loanOffer: loanOffer,
      shouldShowDetails: shouldShowDetails,
      scrollAndToggle: scrollAndToggle,
      isPersonal: isPersonal,
      onClick: function onClick() {
        trackNewTealiumConversion();
      },
      order: order,
      onApplyNow: function onApplyNow(args) {
        !!hasLDProvider && trackOfferReferral(loanOffer);
        trackNewTealiumConversion();
        return _onApplyNow(args);
      }
    })]
  });
};

exports.LoanCardBody = LoanCardBody;

var _default = (0, _styledComponents["default"])(LoanCardBody).withConfig({
  componentId: "sc-7mc6of-7"
})([""]);

exports["default"] = _default;
//# sourceMappingURL=body.js.map